import { ComponentProps } from "react";

type Props = ComponentProps<"input"> & {
  children?: React.ReactNode;
};

export default function CheckBox({ children, ...rest }: Props) {
  return (
    <>
      <input type="checkbox" name={rest.name} id={rest.id} {...rest} />
      <label className="flex-label" htmlFor={rest.id}>
        {children && <div>{children}</div>}
      </label>
    </>
  );
}
